import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import useGlobal from '@/composables/useGlobal'
import { isSuperUser } from '@access/permissions'
import { useLogoutConfirm } from '@/composables/useLogoutConfirm'
import {
  logoutResource,
} from '@/services/auth.service'
// import {
//   warehousesListResource,
//   warehouseOptionsResource,
// } from '@/services/warehouse.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'SubHeader',
  setup(__props, { expose: __expose }) {
  __expose();

const { $t } = useGlobal()
const fullURL = ref(window.location.host)
const adminPanelUrl = `${window.location.origin}/control-panel/`

const logout = async () => {
  const question = $t('Are you sure you want to go out?')
  const logout = true
  try {
      await useLogoutConfirm(question)
      const { data: { redirectLink } } = (await logoutResource.execute({}, {}))
      window.location.href = redirectLink
  } catch (e) {
    return Promise.reject(e)
  }
}


const __returned__ = { $t, fullURL, adminPanelUrl, logout, ref, get useGlobal() { return useGlobal }, get isSuperUser() { return isSuperUser }, get useLogoutConfirm() { return useLogoutConfirm }, get logoutResource() { return logoutResource } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})